const CLIENT_KEY_CODE_MAPPINGS = [
  {
    busUnit: 'FOR',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'U4FAB',
  },
  {
    busUnit: 'FOR',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'U4FAC',
  },
  {
    busUnit: 'FOR',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'U4FNB',
  },
  {
    busUnit: 'FOR',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'U4FNC',
  },
  {
    busUnit: 'FOR',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'U4FAB',
  },
  {
    busUnit: 'FOR',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'U4FAC',
  },
  {
    busUnit: 'FOR',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'U4FNB',
  },
  {
    busUnit: 'FOR',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'U4FNC',
  },
  {
    busUnit: 'RLG',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'U4XAU1',
  },
  {
    busUnit: 'RLG',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'U4XAU2',
  },
  {
    busUnit: 'RLG',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'U4XNU1',
  },
  {
    busUnit: 'RLG',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'U4XNU2',
  },
  {
    busUnit: 'RLG',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'U4XAU1',
  },
  {
    busUnit: 'RLG',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'U4XAU2',
  },
  {
    busUnit: 'RLG',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'U4XNU1',
  },
  {
    busUnit: 'RLG',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'U4XNU2',
  },
  {
    busUnit: 'DEF',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'U3SAM',
  },
  {
    busUnit: 'DEF',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'U3SAN',
  },
  {
    busUnit: 'DEF',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'U3SNM',
  },
  {
    busUnit: 'DEF',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'U3SNN',
  },
  {
    busUnit: 'DEF',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'U3SAM',
  },
  {
    busUnit: 'DEF',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'U3SAN',
  },
  {
    busUnit: 'DEF',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'U3SNM',
  },
  {
    busUnit: 'DEF',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'U3SNN',
  },
  {
    busUnit: 'PHP',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'FDNUPHLL',
  },
  {
    busUnit: 'PHP',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'FDNUPHLL',
  },
  {
    busUnit: 'PHP',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'FDNUPHLL',
  },
  {
    busUnit: 'PHP',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'FDNUPHLL',
  },
  {
    busUnit: 'PHP',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'FDNUPHLL',
  },
  {
    busUnit: 'PHP',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'FDNUPHLL',
  },
  {
    busUnit: 'PHP',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'FDNUPHLL',
  },
  {
    busUnit: 'PHP',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'FDNUPHLL',
  },
  {
    busUnit: 'BLP',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'FDNUBLUEP',
  },
  {
    busUnit: 'BLP',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'FDNUBLUEP',
  },
  {
    busUnit: 'BLP',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'FDNUBLUEP',
  },
  {
    busUnit: 'BLP',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'FDNUBLUEP',
  },
  {
    busUnit: 'BLP',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'FDNUBLUEP',
  },
  {
    busUnit: 'BLP',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'FDNUBLUEP',
  },
  {
    busUnit: 'BLP',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'FDNUBLUEP',
  },
  {
    busUnit: 'BLP',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'FDNUBLUEP',
  },
  {
    busUnit: 'GRD',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'FDWUGUDW',
  },
  {
    busUnit: 'GRD',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'FDWUGUDW',
  },
  {
    busUnit: 'GRD',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'FDWUGUDW',
  },
  {
    busUnit: 'GRD',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'FDWUGUDW',
  },
  {
    busUnit: 'GRD',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'FDWUGUDW',
  },
  {
    busUnit: 'GRD',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'FDWUGUDW',
  },
  {
    busUnit: 'GRD',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'FDWUGUDW',
  },
  {
    busUnit: 'GRD',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'FDWUGUDW',
  },
  {
    busUnit: 'HUA',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'FDXUHEAW',
  },
  {
    busUnit: 'HUA',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'FDXUHEAW',
  },
  {
    busUnit: 'HUA',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'FDXUHEAW',
  },
  {
    busUnit: 'HUA',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'FDXUHEAW',
  },
  {
    busUnit: 'HUA',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'FDXUHEAW',
  },
  {
    busUnit: 'HUA',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'FDXUHEAW',
  },
  {
    busUnit: 'HUA',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'FDXUHEAW',
  },
  {
    busUnit: 'HUA',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'FDXUHEAW',
  },
  {
    busUnit: 'TWA',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'V9RUEXTU',
  },
  {
    busUnit: 'TWA',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'V9RUEXTU',
  },
  {
    busUnit: 'TWA',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'V9RUEXTU',
  },
  {
    busUnit: 'TWA',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'V9RUEXTU',
  },
  {
    busUnit: 'TWA',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'V9RUEXTU',
  },
  {
    busUnit: 'TWA',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'V9RUEXTU',
  },
  {
    busUnit: 'TWA',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'V9RUEXTU',
  },
  {
    busUnit: 'TWA',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'V9RUEXTU',
  },
  {
    busUnit: 'INS',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'V9RUSMSU',
  },
  {
    busUnit: 'INS',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'V9RUSMSU',
  },
  {
    busUnit: 'INS',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'V9RUSMSU',
  },
  {
    busUnit: 'INS',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'V9RUSMSU',
  },
  {
    busUnit: 'INS',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'V9RUSMSU',
  },
  {
    busUnit: 'INS',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'V9RUSMSU',
  },
  {
    busUnit: 'INS',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'V9RUSMSU',
  },
  {
    busUnit: 'INS',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'V9RUSMSU',
  },
  {
    busUnit: 'AON',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'V9RUHEWU',
  },
  {
    busUnit: 'AON',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'V9RUHEWU',
  },
  {
    busUnit: 'AON',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'V9RUHEWU',
  },
  {
    busUnit: 'AON',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'V9RUHEWU',
  },
  {
    busUnit: 'AON',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'V9RUHEWU',
  },
  {
    busUnit: 'AON',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'V9RUHEWU',
  },
  {
    busUnit: 'AON',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'V9RUHEWU',
  },
  {
    busUnit: 'AON',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'V9RUHEWU',
  },
  {
    busUnit: 'EHA',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'VAGEHU1',
  },
  {
    busUnit: 'EHA',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'VAGEHU1',
  },
  {
    busUnit: 'EHA',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'VAGEHU1',
  },
  {
    busUnit: 'EHA',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'VAGEHU1',
  },
  {
    busUnit: 'EHA',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'VAGEHU1',
  },
  {
    busUnit: 'EHA',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'VAGEHU1',
  },
  {
    busUnit: 'EHA',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'VAGEHU1',
  },
  {
    busUnit: 'EHA',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'VAGEHU1',
  },
  {
    busUnit: 'SEQ',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'VARUSENQ',
  },
  {
    busUnit: 'SEQ',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'VARUSENQ',
  },
  {
    busUnit: 'SEQ',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'VARUSENQ',
  },
  {
    busUnit: 'SEQ',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'VARUSENQ',
  },
  {
    busUnit: 'SEQ',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'VARUSENQ',
  },
  {
    busUnit: 'SEQ',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'VARUSENQ',
  },
  {
    busUnit: 'SEQ',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'VARUSENQ',
  },
  {
    busUnit: 'SEQ',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'VARUSENQ',
  },
  {
    busUnit: 'HPO',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'VANUHPLU',
  },
  {
    busUnit: 'HPO',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'VANUHPLU',
  },
  {
    busUnit: 'HPO',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'VANUHPLU',
  },
  {
    busUnit: 'HPO',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'VANUHPLU',
  },
  {
    busUnit: 'HPO',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'VANUHPLU',
  },
  {
    busUnit: 'HPO',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'VANUHPLU',
  },
  {
    busUnit: 'HPO',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'VANUHPLU',
  },
  {
    busUnit: 'HPO',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'VANUHPLU',
  },
  {
    busUnit: 'MRS',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'VAZUUHCC',
  },
  {
    busUnit: 'MRS',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'VAZUUHCC',
  },
  {
    busUnit: 'MRS',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'VAZUUHCC',
  },
  {
    busUnit: 'MRS',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'VAZUUHCC',
  },
  {
    busUnit: 'MRS',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'VAZUUHCC',
  },
  {
    busUnit: 'MRS',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'VAZUUHCC',
  },
  {
    busUnit: 'MRS',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'VAZUUHCC',
  },
  {
    busUnit: 'MRS',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'VAZUUHCC',
  },
  {
    busUnit: 'MER',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'VANUTRAU',
  },
  {
    busUnit: 'MER',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'VANUTRAU',
  },
  {
    busUnit: 'MER',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'VANUTRAU',
  },
  {
    busUnit: 'MER',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'VANUTRAU',
  },
  {
    busUnit: 'MER',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'VANUTRAU',
  },
  {
    busUnit: 'MER',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'VANUTRAU',
  },
  {
    busUnit: 'MER',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'VANUTRAU',
  },
  {
    busUnit: 'MER',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'VANUTRAU',
  },
  {
    busUnit: 'HEM',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'VCEUUHCP',
  },
  {
    busUnit: 'HEM',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'VCEUUHCP',
  },
  {
    busUnit: 'HEM',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'VCEUUHCP',
  },
  {
    busUnit: 'HEM',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'VCEUUHCP',
  },
  {
    busUnit: 'HEM',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'VCEUUHCP',
  },
  {
    busUnit: 'HEM',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'VCEUUHCP',
  },
  {
    busUnit: 'HEM',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'VCEUUHCP',
  },
  {
    busUnit: 'HEM',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'VCEUUHCP',
  },
  {
    busUnit: 'ETE',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'VCFUUHCA',
  },
  {
    busUnit: 'ETE',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'VCFUUHCA',
  },
  {
    busUnit: 'ETE',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'VCFUUHCA',
  },
  {
    busUnit: 'ETE',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'VCFUUHCA',
  },
  {
    busUnit: 'ETE',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'VCFUUHCA',
  },
  {
    busUnit: 'ETE',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'VCFUUHCA',
  },
  {
    busUnit: 'ETE',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'VCFUUHCA',
  },
  {
    busUnit: 'ETE',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'VCFUUHCA',
  },
  {
    busUnit: 'FFI',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'VCPUUHCP',
  },
  {
    busUnit: 'FFI',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'VCPUUHCP',
  },
  {
    busUnit: 'FFI',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'VCPUUHCP',
  },
  {
    busUnit: 'FFI',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'VCPUUHCP',
  },
  {
    busUnit: 'FFI',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'VCPUUHCP',
  },
  {
    busUnit: 'FFI',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'VCPUUHCP',
  },
  {
    busUnit: 'FFI',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'VCPUUHCP',
  },
  {
    busUnit: 'FFI',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'VCPUUHCP',
  },
  {
    busUnit: 'GMG',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'VCRUUHCP',
  },
  {
    busUnit: 'GMG',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'VCRUUHCP',
  },
  {
    busUnit: 'GMG',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'VCRUUHCP',
  },
  {
    busUnit: 'GMG',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'VCRUUHCP',
  },
  {
    busUnit: 'GMG',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'VCRUUHCP',
  },
  {
    busUnit: 'GMG',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'VCRUUHCP',
  },
  {
    busUnit: 'GMG',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'VCRUUHCP',
  },
  {
    busUnit: 'GMG',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'VCRUUHCP',
  },
  {
    busUnit: 'SMI',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'VCTUUHCE',
  },
  {
    busUnit: 'SMI',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'VCTUUHCE',
  },
  {
    busUnit: 'SMI',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'VCTUUHCE',
  },
  {
    busUnit: 'SMI',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'VCTUUHCE',
  },
  {
    busUnit: 'SMI',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'VCTUUHCE',
  },
  {
    busUnit: 'SMI',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'VCTUUHCE',
  },
  {
    busUnit: 'SMI',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'VCTUUHCE',
  },
  {
    busUnit: 'SMI',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'VCTUUHCE',
  },
  {
    busUnit: 'GHI',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'VCUUUHCE',
  },
  {
    busUnit: 'GHI',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'VCUUUHCE',
  },
  {
    busUnit: 'GHI',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'VCUUUHCE',
  },
  {
    busUnit: 'GHI',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'VCUUUHCE',
  },
  {
    busUnit: 'GHI',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'VCUUUHCE',
  },
  {
    busUnit: 'GHI',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'VCUUUHCE',
  },
  {
    busUnit: 'GHI',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'VCUUUHCE',
  },
  {
    busUnit: 'GHI',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'VCUUUHCE',
  },
  {
    busUnit: 'SVG',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'VCXUUHCE',
  },
  {
    busUnit: 'SVG',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'VCXUUHCE',
  },
  {
    busUnit: 'SVG',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'VCXUUHCE',
  },
  {
    busUnit: 'SVG',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'VCXUUHCE',
  },
  {
    busUnit: 'SVG',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'VCXUUHCE',
  },
  {
    busUnit: 'SVG',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'VCXUUHCE',
  },
  {
    busUnit: 'SVG',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'VCXUUHCE',
  },
  {
    busUnit: 'SVG',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'VCXUUHCE',
  },
  {
    busUnit: 'HEI',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'VDDUUHCA',
  },
  {
    busUnit: 'HEI',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'VDDUUHCA',
  },
  {
    busUnit: 'HEI',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'VDDUUHCA',
  },
  {
    busUnit: 'HEI',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'VDDUUHCA',
  },
  {
    busUnit: 'HEI',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'VDDUUHCA',
  },
  {
    busUnit: 'HEI',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'VDDUUHCA',
  },
  {
    busUnit: 'HEI',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'VDDUUHCA',
  },
  {
    busUnit: 'HEI',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'VDDUUHCA',
  },
  {
    busUnit: 'ENT',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'VDUUUHCE',
  },
  {
    busUnit: 'ENT',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'VDUUUHCE',
  },
  {
    busUnit: 'ENT',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'VDUUUHCE',
  },
  {
    busUnit: 'ENT',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'VDUUUHCE',
  },
  {
    busUnit: 'ENT',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'VDUUUHCE',
  },
  {
    busUnit: 'ENT',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'VDUUUHCE',
  },
  {
    busUnit: 'ENT',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'VDUUUHCE',
  },
  {
    busUnit: 'ENT',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'VDUUUHCE',
  },
  {
    busUnit: 'EIL',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'VDSUUHCE',
  },
  {
    busUnit: 'EIL',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'VDSUUHCE',
  },
  {
    busUnit: 'EIL',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'VDSUUHCE',
  },
  {
    busUnit: 'EIL',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'VDSUUHCE',
  },
  {
    busUnit: 'EIL',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'VDSUUHCE',
  },
  {
    busUnit: 'EIL',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'VDSUUHCE',
  },
  {
    busUnit: 'EIL',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'VDSUUHCE',
  },
  {
    busUnit: 'EIL',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'VDSUUHCE',
  },
  {
    busUnit: 'GOH',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'VDTUUHCG',
  },
  {
    busUnit: 'GOH',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'VDTUUHCG',
  },
  {
    busUnit: 'GOH',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'VDTUUHCG',
  },
  {
    busUnit: 'GOH',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'VDTUUHCG',
  },
  {
    busUnit: 'GOH',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'VDTUUHCG',
  },
  {
    busUnit: 'GOH',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'VDTUUHCG',
  },
  {
    busUnit: 'GOH',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'VDTUUHCG',
  },
  {
    busUnit: 'GOH',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'VDTUUHCG',
  },
  {
    busUnit: 'EIP',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'VDTUUHCE',
  },
  {
    busUnit: 'EIP',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'VDTUUHCE',
  },
  {
    busUnit: 'EIP',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'VDTUUHCE',
  },
  {
    busUnit: 'EIP',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'VDTUUHCE',
  },
  {
    busUnit: 'EIP',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'VDTUUHCE',
  },
  {
    busUnit: 'EIP',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'VDTUUHCE',
  },
  {
    busUnit: 'EIP',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'VDTUUHCE',
  },
  {
    busUnit: 'EIP',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'VDTUUHCE',
  },
  {
    busUnit: 'BIG',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'VDUUUHCB',
  },
  {
    busUnit: 'BIG',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'VDUUUHCB',
  },
  {
    busUnit: 'BIG',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'VDUUUHCB',
  },
  {
    busUnit: 'BIG',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'VDUUUHCB',
  },
  {
    busUnit: 'BIG',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'VDUUUHCB',
  },
  {
    busUnit: 'BIG',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'VDUUUHCB',
  },
  {
    busUnit: 'BIG',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'VDUUUHCB',
  },
  {
    busUnit: 'BIG',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'VDUUUHCB',
  },
  {
    busUnit: 'IMI',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'VDVUUHCI',
  },
  {
    busUnit: 'IMI',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'VDVUUHCI',
  },
  {
    busUnit: 'IMI',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'VDVUUHCI',
  },
  {
    busUnit: 'IMI',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'VDVUUHCI',
  },
  {
    busUnit: 'IMI',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'VDVUUHCI',
  },
  {
    busUnit: 'IMI',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'VDVUUHCI',
  },
  {
    busUnit: 'IMI',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'VDVUUHCI',
  },
  {
    busUnit: 'IMI',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'VDVUUHCI',
  },
  {
    busUnit: 'WIS',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'VDUUHCW',
  },
  {
    busUnit: 'WIS',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'VDUUHCW',
  },
  {
    busUnit: 'WIS',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'VDUUHCW',
  },
  {
    busUnit: 'WIS',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'VDUUHCW',
  },
  {
    busUnit: 'WIS',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'VDUUHCW',
  },
  {
    busUnit: 'WIS',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'VDUUHCW',
  },
  {
    busUnit: 'WIS',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'VDUUHCW',
  },
  {
    busUnit: 'WIS',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'VDUUHCW',
  },
  {
    busUnit: 'HIS',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'VDWUUHCP',
  },
  {
    busUnit: 'HIS',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'VDWUUHCP',
  },
  {
    busUnit: 'HIS',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'VDWUUHCP',
  },
  {
    busUnit: 'HIS',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'VDWUUHCP',
  },
  {
    busUnit: 'HIS',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'VDWUUHCP',
  },
  {
    busUnit: 'HIS',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'VDWUUHCP',
  },
  {
    busUnit: 'HIS',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'VDWUUHCP',
  },
  {
    busUnit: 'HIS',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'VDWUUHCP',
  },
  {
    busUnit: 'HPT',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'VEPUUHCE',
  },
  {
    busUnit: 'HPT',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'VEPUUHCE',
  },
  {
    busUnit: 'HPT',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'VEPUUHCE',
  },
  {
    busUnit: 'HPT',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'VEPUUHCE',
  },
  {
    busUnit: 'HPT',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'VEPUUHCE',
  },
  {
    busUnit: 'HPT',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'VEPUUHCE',
  },
  {
    busUnit: 'HPT',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'VEPUUHCE',
  },
  {
    busUnit: 'HPT',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'VEPUUHCE',
  },
  {
    busUnit: 'UIG',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'VDTUUHCA',
  },
  {
    busUnit: 'UIG',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'VDTUUHCA',
  },
  {
    busUnit: 'UIG',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'VDTUUHCA',
  },
  {
    busUnit: 'UIG',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'VDTUUHCA',
  },
  {
    busUnit: 'UIG',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'VDTUUHCA',
  },
  {
    busUnit: 'UIG',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'VDTUUHCA',
  },
  {
    busUnit: 'UIG',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'VDTUUHCA',
  },
  {
    busUnit: 'UIG',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'VDTUUHCA',
  },
  {
    busUnit: 'EPH',
    commLanguage: '1',
    type: '1',
    assnInd: 'A',
    keyCode: 'FEZUHCHW',
  },
  {
    busUnit: 'EPH',
    commLanguage: '1',
    type: '30',
    assnInd: 'A',
    keyCode: 'FEZUHCHW',
  },
  {
    busUnit: 'EPH',
    commLanguage: '1',
    type: '1',
    assnInd: 'N',
    keyCode: 'FEZUHCHW',
  },
  {
    busUnit: 'EPH',
    commLanguage: '1',
    type: '30',
    assnInd: 'N',
    keyCode: 'FEZUHCHW',
  },
  {
    busUnit: 'EPH',
    commLanguage: '2',
    type: '1',
    assnInd: 'A',
    keyCode: 'FEZUHCHW',
  },
  {
    busUnit: 'EPH',
    commLanguage: '2',
    type: '30',
    assnInd: 'A',
    keyCode: 'FEZUHCHW',
  },
  {
    busUnit: 'EPH',
    commLanguage: '2',
    type: '1',
    assnInd: 'N',
    keyCode: 'FEZUHCHW',
  },
  {
    busUnit: 'EPH',
    commLanguage: '2',
    type: '30',
    assnInd: 'N',
    keyCode: 'FEZUHCHW',
  },
];

export function findKeyCode(busUnit, lang, type, assnInd) {
  let keyCodeMapping = CLIENT_KEY_CODE_MAPPINGS.find(keyCDMapping => (
    keyCDMapping.assnInd === assnInd &&
    keyCDMapping.busUnit === busUnit &&
    keyCDMapping.commLanguage === lang &&
    keyCDMapping.type === type),
  );

  if (!keyCodeMapping) {
    keyCodeMapping = CLIENT_KEY_CODE_MAPPINGS.find(keyCDMapping => (
      keyCDMapping.assnInd === assnInd &&
      keyCDMapping.busUnit === 'DEF' &&
      keyCDMapping.commLanguage === lang &&
      keyCDMapping.type === type),
    );
  }
  return keyCodeMapping.keyCode;
}

export default findKeyCode;



// WEBPACK FOOTER //
// ./src/app/containers/Utils/keyCodeMapping.js